import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Upload, Button, Icon } from 'antd';
import IconButton from 'material-ui/IconButton';
import FileUpload from '@material-ui/icons/FileUpload';

import QUERY from '../graphql/queries/s3PostSignatureQuery.graphql';

const s3BucketUrl = 'http://ecp14.s3.amazonaws.com';

class S3Upload extends Component {
  state = {
    fileExtension: null,
    contentType: null,
  };

  render() {
    const { fileName, s3Key, onChange, buttonText, disabled } = this.props;
    const { loading, s3PostSignature } = this.props.data;
    if (loading) {
      return (
        <IconButton disabled aria-label="Upload document" color="primary">
          <FileUpload />
        </IconButton>
      );
    }

    const data = {
      key: s3Key,
      policy: s3PostSignature.policy,
      'x-amz-algorithm': 'AWS4-HMAC-SHA256',
      'x-amz-credential': s3PostSignature.credential,
      'x-amz-date': s3PostSignature.date,
      'x-amz-signature': s3PostSignature.signature,
    };
    if (this.state.fileExtension) data['Content-Disposition'] = `attachment; filename="${fileName}.${this.state.fileExtension}"`;
    else data['Content-Disposition'] = `attachment; filename="${fileName}"`;
    if (this.state.contentType) data['Content-Type'] = this.state.contentType;

    return (
      <Upload
        name="file"
        action={s3BucketUrl}
        data={data}
        onChange={onChange}
        // beforeUpload={(file) => (
        //   this.setState({
        //     contentType: file.type,
        //     fileExtension: file.name.split('.').pop(),
        //   }, () => (true))
        // )}
        beforeUpload={() => (false)}
        disabled={disabled}
      >
        {
          buttonText ?
            <Button>
              <Icon type="upload" /> {buttonText}
            </Button>
            :
            <IconButton aria-label="Upload document" color="primary">
              <FileUpload />
            </IconButton>
        }
      </Upload>
    );
  }
}

S3Upload.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    s3PostSignature: PropTypes.shape({
      id: PropTypes.number.isRequired,
      policy: PropTypes.string.isRequired,
      signature: PropTypes.string.isRequired,
      credential: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
    }),
  }).isRequired,
  s3Key: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  buttonText: PropTypes.string,
  disabled: PropTypes.bool,
};

S3Upload.defaultProps = {
  onChange: null,
  buttonText: null,
  disabled: false,
};

export default graphql(QUERY)(S3Upload);



// WEBPACK FOOTER //
// ./src/components/S3Upload.jsx